import { useMutation, useQueryClient } from 'react-query';

import { taskApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

const useDeleteTask = (assetId: string) => {
  const queryClient = useQueryClient();

  return useMutation((taskId: string) => taskApi.delete(assetId, taskId), {
    onSuccess: () => {
      trackEvent('Task', 'delete');
      queryClient.invalidateQueries(['tasks', assetId]);
      queryClient.invalidateQueries(['my-tasks']);
    },
  });
};

export default useDeleteTask;
